import { useEffect, useRef, useState } from "react"
import { useReactToPrint } from "react-to-print"
import { useTranslation } from "react-i18next"
import { TransportItem } from "./TransportItem"
import openIcon from "./selecticon.png"
import { IFetchPtData } from "@types"
import { useActionsFetchPtDataQuery } from "../../store/Features/actions/actionsFetchPtData-api-slice"

import { SkeletonLoader } from "components"
export const FetchPtData = () => {
 // language translator
 const { t } = useTranslation("translation")
 const { data, isLoading } = useActionsFetchPtDataQuery()

 const [selectedData, setSelectedData] = useState<IFetchPtData[]>([])
 const [startIndex, setStartIndex] = useState(0)
 const componentRef = useRef(null)

 useEffect(() => {
  if (data) {
   setSelectedData(data)
  }
 }, [data])

 const cardsPerPage = 3

 const handleNext = () => {
  if (startIndex + cardsPerPage < selectedData.length) {
   setStartIndex(startIndex + cardsPerPage)
  }
 }

 const handlePrev = () => {
  if (startIndex - cardsPerPage >= 0) {
   setStartIndex(startIndex - cardsPerPage)
  }
 }
 // splitting array
 const Allcards = selectedData.slice(startIndex, startIndex + cardsPerPage)

 // method for printing the devices status
 const handlePrint = useReactToPrint({
  content: () => componentRef.current,
 })

 return (
  <div>
   <div className="flex lg:flex-row flex-col justify-between lg:items-center w-[98%] mx-auto py-4">
    <div>
     <h1 className="font-semibold text-2xl">{t("retrievePublicTransportData")}</h1>
     <p className="text-sm">
      Here you can transfer the public transport data of the selected systems to the head office
     </p>
    </div>

    <div className="w-full lg:w-[18%] flex  justify-end lg:justify-between lg:items-center">
     <button
      className="bg-dark-yellow px-6 py-1 font-semibold  rounded hover:bg-[#FED749] hover:text-white "
      onClick={() => {
       handlePrint()
      }}
     >
      {t("print")}
     </button>
     <div className="flex lg:w-[35%] lg:justify-between">
      <button
       onClick={handlePrev}
       disabled={startIndex === 0}
       className={`bg-white h-6 w-6 rounded-lg flex items-center justify-center ${
        startIndex === 0 ? "opacity-40" : ""
       }`}
      >
       <img className="rotate-[-90deg]" src={openIcon} alt="prev" />
      </button>
      <button
       disabled={startIndex + cardsPerPage >= selectedData.length}
       onClick={handleNext}
       className={`bg-white h-6 w-6 rounded-lg flex items-center justify-center ${
        startIndex + cardsPerPage >= selectedData.length ? "opacity-40" : ""
       }`}
      >
       <img className="rotate-90" src={openIcon} alt="next" />
      </button>
     </div>
    </div>
   </div>

   <div
    ref={componentRef}
    className="flex lg:flex-row flex-col gap-3 overflow-x-scroll  hide-scroll-icon"
   >
    {isLoading ? (
     <div className="w-[98%] mx-auto">
      <SkeletonLoader count={6} />
     </div>
    ) : (
     Allcards.map((item, index) => (
      <div key={index} className="min-w-[45%] ">
       {/* =========== StatusItem component for removing duplicates ====== */}
       <TransportItem item={item} index={index} isLoading={isLoading} />
      </div>
     ))
    )}
   </div>
  </div>
 )
}
